import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

import "../styles/DemoDashboard.css";

const categories = [
  {
    title: "Premium Current Affairs",
    path: "/premium-current-affairs",
    img: "https://cdn-icons-png.flaticon.com/512/2991/2991148.png",
    tag: "Daily Strategic Updates"
  },
  {
    title: "Premium Question Banks",
    path: "/premium-question-bank",
    img: "https://cdn-icons-png.flaticon.com/512/3135/3135755.png",
    tag: "Topic-Wise Practice"
  },
  {
    title: "Premium Notes",
    path: "/premium-notes",
    img: "https://cdn-icons-png.flaticon.com/512/2921/2921222.png",
    tag: "High Retention Notes"
  },
  {
    title: "Premium Mock Exams",
    path: "/premium-mock",
    img: "https://cdn-icons-png.flaticon.com/512/4315/4315445.png",
    tag: "Exam Simulation"
  },
  {
    title: "Detailed UPSC Analysis",
    path: "/upsc-analysis",
    img: "https://cdn-icons-png.flaticon.com/512/4149/4149643.png",
    tag: "Trend Intelligence"
  },
  {
    title: "AI Coaching",
    path: "/ai-coaching",
    img: "https://cdn-icons-png.flaticon.com/512/4712/4712109.png",
    tag: "Smart Guidance"
  },
  {
    title: "Premium Law Structure",
    path: "/law-structure",
    img: "https://cdn-icons-png.flaticon.com/512/3063/3063822.png",
    tag: "Structured Learning"
  },
  {
    title: "Premium Law GS1",
    path: "/law-gs1",
    img: "https://cdn-icons-png.flaticon.com/512/2910/2910791.png",
    tag: "GS1 Law Coverage"
  },
  {
    title: "Premium Law GS2",
    path: "/law-gs2",
    img: "https://cdn-icons-png.flaticon.com/512/2910/2910791.png",
    tag: "GS2 Governance Focus"
  },
  {
    title: "Premium Law GS3",
    path: "/law-gs3",
    img: "https://cdn-icons-png.flaticon.com/512/2910/2910791.png",
    tag: "GS3 Applied Topics"
  },
  {
    title: "Premium Law GS4",
    path: "/law-gs4",
    img: "https://cdn-icons-png.flaticon.com/512/2910/2910791.png",
    tag: "Ethics + Case Studies"
  },
  {
    title: "Premium IPC Sections",
    path: "/ipc-sections",
    img: "https://cdn-icons-png.flaticon.com/512/1048/1048953.png",
    tag: "Law Reference Vault"
  }
];

export default function DemoDashboard() {
  const navigate = useNavigate();
  const { isPremium } = useContext(AuthContext);

  return (
    <section
      className="py-5"
      style={{
        background:
          "radial-gradient(circle at top left, rgba(56,189,248,0.08), transparent 22%), radial-gradient(circle at top right, rgba(34,197,94,0.08), transparent 22%), linear-gradient(135deg, #020617, #0f172a, #111827)"
      }}
    >
      <div className="container">
        {/* TOP */}
        <div className="text-center mb-5">
          <div style={topBadgeStyle}>PREMIUM DASHBOARD PREVIEW</div>

          <h2
            className="fw-bold mt-4"
            style={{
              color: "#f8fafc",
              fontSize: "clamp(1.9rem, 4vw, 2.7rem)",
              lineHeight: "1.2"
            }}
          >
            Explore Your UPSC Premium Learning System
          </h2>

          <p
            style={{
              color: "#cbd5e1",
              maxWidth: "860px",
              margin: "16px auto 0",
              fontSize: "1rem",
              lineHeight: "1.9"
            }}
          >
            Access structured current affairs, notes, question banks, mock
            exams, law modules and AI-backed learning tools designed to make
            preparation more strategic and high-retention.
          </p>
        </div>

        {/* STATS */}
        <div className="row g-3 mb-5">
          <div className="col-6 col-lg-3">
            <div style={statCardStyle}>
              <h3 style={statNumberStyle}>12+</h3>
              <p style={statTextStyle}>Premium Sections</p>
            </div>
          </div>

          <div className="col-6 col-lg-3">
            <div style={statCardStyle}>
              <h3 style={statNumberStyle}>AI</h3>
              <p style={statTextStyle}>Smart Learning Support</p>
            </div>
          </div>

          <div className="col-6 col-lg-3">
            <div style={statCardStyle}>
              <h3 style={statNumberStyle}>7 Days</h3>
              <p style={statTextStyle}>Weekly Premium Access</p>
            </div>
          </div>

          <div className="col-6 col-lg-3">
            <div style={statCardStyle}>
              <h3 style={statNumberStyle}>UPSC</h3>
              <p style={statTextStyle}>Exam-Focused System</p>
            </div>
          </div>
        </div>

        {/* CARDS */}
        <div className="row g-4">
          {categories.map((cat, index) => (
            <div key={index} className="col-12 col-sm-6 col-lg-4 col-xl-3">
              <div
                style={cardStyle}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                  e.currentTarget.style.boxShadow =
                    "0 22px 45px rgba(0,0,0,0.28)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0px)";
                  e.currentTarget.style.boxShadow =
                    "0 14px 32px rgba(0,0,0,0.22)";
                }}
              >
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div style={iconWrapStyle}>
                    <img
                      src={cat.img}
                      alt={cat.title}
                      style={{
                        width: "42px",
                        height: "42px",
                        objectFit: "contain"
                      }}
                    />
                  </div>

                  <span
                    style={{
                      padding: "7px 12px",
                      borderRadius: "999px",
                      background: isPremium
                        ? "rgba(34,197,94,0.12)"
                        : "rgba(250,204,21,0.12)",
                      border: isPremium
                        ? "1px solid rgba(34,197,94,0.18)"
                        : "1px solid rgba(250,204,21,0.18)",
                      color: isPremium ? "#bbf7d0" : "#fde68a",
                      fontSize: "0.75rem",
                      fontWeight: 800
                    }}
                  >
                    {isPremium ? "UNLOCKED" : "PREVIEW"}
                  </span>
                </div>

                <h5
                  style={{
                    color: "#f8fafc",
                    fontWeight: 800,
                    fontSize: "1rem",
                    lineHeight: "1.5",
                    minHeight: "52px"
                  }}
                >
                  {cat.title}
                </h5>

                <p
                  style={{
                    color: "#94a3b8",
                    fontSize: "0.92rem",
                    lineHeight: "1.75",
                    marginBottom: "18px",
                    minHeight: "48px"
                  }}
                >
                  {cat.tag}
                </p>

                <div
                  onClick={() => {
                    if (isPremium) {
                      navigate(`${cat.path}`); // REAL CONTENT
                    } else {
                      navigate(`/demo${cat.path}`); // DEMO CONTENT
                    }
                  }}
                  style={{
                    ...actionBarStyle,
                    background: isPremium
                      ? "linear-gradient(135deg, #22c55e, #16a34a)"
                      : "linear-gradient(135deg, #38bdf8, #2563eb)"
                  }}
                >
                  {isPremium ? "Open Content" : "View Demo"}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        {!isPremium && (
          <div className="text-center mt-5 pt-3">
            <div
              style={{
                maxWidth: "760px",
                margin: "0 auto",
                padding: "26px 22px",
                borderRadius: "28px",
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.08)",
                boxShadow: "0 16px 40px rgba(0,0,0,0.18)"
              }}
            >
              <h3
                style={{
                  color: "#f8fafc",
                  fontWeight: 900,
                  marginBottom: "10px"
                }}
              >
                Unlock Full UPSC Premium Access
              </h3>

              <p
                style={{
                  color: "#cbd5e1",
                  lineHeight: "1.8",
                  marginBottom: "18px"
                }}
              >
                Move beyond previews and access the complete preparation system
                built for consistency, structure and confidence.
              </p>

              <button
                className="btn btn-success btn-lg px-4"
                onClick={() => navigate("/subscription")}
                style={{
                  borderRadius: "16px",
                  fontWeight: 800,
                  paddingTop: "12px",
                  paddingBottom: "12px"
                }}
              >
                Start Premium Now
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

/* ================= STYLES ================= */
const topBadgeStyle = {
  display: "inline-block",
  padding: "10px 18px",
  borderRadius: "999px",
  background: "rgba(56,189,248,0.10)",
  border: "1px solid rgba(56,189,248,0.18)",
  color: "#7dd3fc",
  fontWeight: 800,
  fontSize: "0.82rem",
  letterSpacing: "1px"
};

const statCardStyle = {
  borderRadius: "22px",
  padding: "24px 18px",
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.08)",
  textAlign: "center",
  height: "100%"
};

const statNumberStyle = {
  color: "#f8fafc",
  fontWeight: 900,
  marginBottom: "8px",
  fontSize: "1.7rem"
};

const statTextStyle = {
  color: "#94a3b8",
  marginBottom: 0,
  fontSize: "0.92rem",
  fontWeight: 600
};

const cardStyle = {
  borderRadius: "26px",
  padding: "22px",
  background:
    "linear-gradient(145deg, rgba(15,23,42,0.94), rgba(17,24,39,0.90))",
  border: "1px solid rgba(255,255,255,0.08)",
  boxShadow: "0 14px 32px rgba(0,0,0,0.22)",
  transition: "all 0.25s ease",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between"
};

const iconWrapStyle = {
  width: "70px",
  height: "70px",
  borderRadius: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "rgba(56,189,248,0.10)",
  border: "1px solid rgba(56,189,248,0.18)"
};

const actionBarStyle = {
  marginTop: "auto",
  width: "100%",
  padding: "13px 16px",
  borderRadius: "16px",
  color: "#ffffff",
  fontWeight: 900,
  fontSize: "0.94rem",
  textAlign: "center",
  cursor: "pointer",
  border: "none",
  boxShadow: "0 12px 24px rgba(0,0,0,0.18)"
};